import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout";
import Home from "./pages/home/Home";
import ContactUs from "./pages/contact-us/Contact";
import Faqs from "./pages/faqs/Faqs";
import AboutUs from "./pages/about-us/About";
import Products from "./pages/products/Products";
import Services from "./pages/services/Services";
import SliderContext from "./components/sliderContext";
import { useState, useEffect } from "react";
import Gallery from "./pages/gallery/Gallery";
import IVisitNg from "./pages/product-detail/ivisit";
import BrandCollect from "./pages/product-detail/brandcollect";
import Brems from "./pages/product-detail/brems";
import Dokmee from "./pages/product-detail/dokmee";
import EProcure from "./pages/product-detail/e-procure";
import EGovernment from "./pages/product-detail/e-government";
import EBudget from "./pages/product-detail/e-budget";
import Hostcoman from "./pages/product-detail/hostcoman";

function App() {
  const [sliderOpen, setSliderOpen] = useState(false);
  const [sliderValue, setSliderValue] = useState("");

  useEffect(() => {
    document.body.style.overflow = sliderOpen ? "hidden" : "auto";
  }, [sliderOpen]);

  return (
    <SliderContext.Provider
      value={{ sliderOpen, setSliderOpen, sliderValue, setSliderValue }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
          </Route>
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/product/brandcollect" element={<BrandCollect />} />
          <Route path="/product/ivisitng" element={<IVisitNg />} />
          <Route path="/product/brems" element={<Brems />} />
          <Route path="/product/dokmee" element={<Dokmee />} />
          <Route path="/product/eprocure" element={<EProcure />} />
          <Route path="/product/egovsuite" element={<EGovernment />} />
          <Route path="/product/ebudgetsuite" element={<EBudget />} />
          <Route path="/product/hostcoman" element={<Hostcoman />} />
        </Routes>
      </BrowserRouter>
    </SliderContext.Provider>
  );
}

export default App;
